<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="flex flex-col justify-center items-start grid-toolbar-buttons-group-container w-p-100">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs" iconClass="fas fa-calendar-week"></particle-breadcrumbs>
    </div>
    <div class="toggle-buttons-view flex flex-col justify-end items-start">
      <mat-button-toggle-group #group="matButtonToggleGroup" class="view-change-toggle-container m-t-10">
        <mat-button-toggle value="center" [routerLink]="'/task-manager/card'">
          <i class="far fa-columns active"></i>
        </mat-button-toggle>
        <mat-button-toggle value="left" [routerLink]="'/task-manager/grid'">
          <i class="far fa-th"></i>
        </mat-button-toggle>

      </mat-button-toggle-group>
    </div>
  </div>
  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->
        <div class="content">
          <div class="p-t-30 flex flex-col flex flex-col full-grow-no-shrink-no-basis">
            <div class="board-list-item-wrapper  p-lr-13 m-b-20" *ngFor="let tileGroup of tileGroups">
              <div class="board-list-item-title">{{tileGroup.title}}</div>
              <div class="board-list-item-container flex flex-wrap flex-row auto-flex">
                <div [ngClass]="tile.isFavorite ? 'board-list-item favorite' : 'board-list-item'"
                     *ngFor="let tile of tileGroup.tiles" (click)="navigateToBoardTile(tile)"
                     [attr.data-cy]="'board-tile-' + tile.title"
                >
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu"
                          class="no-animation-btn icon-dropdown-button three-dot" (click)="stopPropagating($event)"
                          [attr.data-cy]="'board-tile-menu-' + tile.title">
                    <i class="far fa-ellipsis-h"></i>
                  </button>
                  <mat-menu #actionMenu="matMenu" class="activity-menu" [overlapTrigger]="false">
                    <button mat-menu-item class="" (click)="openBoard(tile)" data-cy="board-tile-item-Open">
                      <span>Open</span>
                    </button>
                    <button mat-menu-item class="" *ngIf="hasPermission(tile) && (isCustom(tile) || isPersonal(tile))"
                            (click)="renameBoard(tile)" data-cy="board-tile-item-Rename">
                      <span>Rename</span> <!--{{node.item?.questionType}}-->
                    </button>
                    <!--                    Don't delete the below lines, We will need the manage member button in future. It is disable for now.-->
                    <!--                    <button mat-menu-item class="" *ngIf = "isCustom(tile) || isTeam(tile)" (click)="openManageMembersDialog(tile)">-->
                    <!--                      <span>Manage Members</span> &lt;!&ndash;{{node.item?.questionType}}&ndash;&gt;-->
                    <!--                    </button>-->
                    <button mat-menu-item class="" *ngIf="hasPermission(tile) && (isCustom(tile) || isPersonal(tile))"
                            (click)="deleteBoard(tile)" data-cy="board-tile-item-Delete">
                      <span>Delete</span> <!--{{node.item?.questionType}}-->
                    </button>
                  </mat-menu>
                  <div>{{tile.title}}</div>
                  <span *ngIf="!tile.isFavorite" class="footer" (click)="markAsFavorite($event,tile)"
                        [attr.data-cy]="'board-tile-favourite-' + tile.title">
                    <i [matTooltip]="'Add to Favorites'" class="far fa-star"></i>
                  </span>
                  <span class="footer" (click)="markAsFavorite($event,tile)"
                        [ngStyle]="{display:tile.isFavorite? 'block': 'none' }"
                        [attr.data-cy]="'board-tile-unfavourite-' + tile.title">
                    <i [matTooltip]="'Remove from Favorites'" class="fas fa-star"></i>
                  </span>
                </div>
                <div class="add-board" *ngIf="tileGroup.canAddBoard"
                     (click)="addBoard(tileGroup)"
                     [attr.data-cy]="'add-board-' + tileGroup.title">
                  <div class="flex flex-row justify-start items-center">
                    <i class="far fa-plus"></i>
                    <div>Add Board</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
  </mat-sidenav-container>
</div>
